<template>
  <div ref="chart" style="width: 100%;height:400px;"></div>
</template>
<script>
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { LineChart, PieChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  PieChart,
  CanvasRenderer,
  UniversalTransition
]);

export default {
  name: "StatChart",
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    loading(){
      return !this.$store.state[this.type].loaded
    }
  },
  methods: {
    displayChart(){
      var myChart = echarts.init(this.$refs.chart);
      var option;

      if( this.type == 'invitations' ){
        const time = [5,4,3,2,1,0].map(i => this.$dayjs().startOfDay().subtract(i, "week"))
        time[time.length-1] = this.$dayjs().startOfDay().add(1, "day").subtract(1, "minute");

        const labels = ['Expirée', 'Désactivée', 'En attente', 'Utilisée'];
        let series = labels.map(name => {
          return {
            name,
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: [0,0,0,0,0],
          }
        })
        this.$store.state.invitations.data.forEach(invitation => {
          for( let i=1; i<time.length; i++ ){
            if( this.$dayjs(invitation.created_at).isBefore(time[i-1]) ) {
              break;
            } else if(this.$dayjs(invitation.created_at).isBefore(time[i]) ) {
              if( invitation.consumed_at ) {
                if( invitation.status == 'expired' ){
                  series[0].data[i-1]++;
                } else if( invitation.status == 'canceled' ){
                  series[1].data[i-1]++;
                } else {
                  series[3].data[i-1]++;
                }
              } else {
                series[2].data[i-1]++;
              }
              break;
            }
          }
        })

        option = {
          title: {
            text: this.title
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: { data: labels, top: 30 },
          color: ['#000','#ee6666', '#fac858', '#91cc75'],
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: time.slice(1).map(t => t.format('D MMM'))
            }
          ],
          yAxis: [{type: 'value'}],
          series
        };

      } else if(this.type == 'communities'){
        let data = this.$store.state.communities.data
          .toSorted((a,b) => b.approved_users_count  - a.approved_users_count)
        let total = data.filter(community => community.approved_users_count > 1)
          .reduce((acc, community) => acc + community.approved_users_count , 0)
        let series = [{
          name: this.title,
          type: 'pie',
          radius: ['40%', '70%'],
          left: '30%',
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold',
              formatter: '{c}'
            }
          },
          labelLine: {
            show: false
          },
          data: data
            .filter(community => community.approved_users_count > 1)
            .map(community => ({
              value: community.approved_users_count,
              name: community.name,
            }))
        }]
        option = {
          title: {
            text: this.title
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            top: '30',
            orient: 'vertical',
            left: 'left',
            type: 'scroll',
            formatter: name => {
              let community = series[0].data.find(d => d.name == name)
              let percent = Math.round(community.value/total*10000)/100;
              return `${name} : ${community.value} (${percent}%)`
            },
          },
          series,
        };
      } else if( this.type == 'loans' ){
        const time = [7,6,5,4,3,2,1,0].map(i => ({
          value: this.$dayjs().startOfDay().subtract(i, "month"),
          communities: [],
        }))
        time[time.length-1].value = this.$dayjs().startOfDay().add(1, "day").subtract(1, "minute");

        this.$store.state.loans.data.forEach(loan => {
          if(!loan.community) return;
          for( let i=1; i<time.length; i++ ){
            if( this.$dayjs(loan.departure_at).isBefore(time[i-1].value) ) {
              break;
            } else if(this.$dayjs(loan.departure_at).isBefore(time[i].value) ) {
              let j = time[i].communities.findIndex(c => c.id == loan.community.id)
              if(j == -1) {
                j = time[i].communities.length
                time[i].communities.push({
                  ...loan.community,
                  num: 0
                })
              }
              time[i].communities[j].num++
            }
          }
        })

        let monthsLabel = []
        let one = []
        let twoFive= []
        let sixTen = []
        let more = []
        time.forEach((month,i) => {
          monthsLabel[i] = month.value.format('MMMM YYYY')
          one[i] = 0
          twoFive[i] = 0
          sixTen[i] = 0
          more[i] = 0
          month.communities.forEach(c => {
            if(c.num == 1) one[i]+= c.num;
            else if(c.num <= 10) twoFive[i]+= c.num;
            else if(c.num <= 20) sixTen[i]+= c.num;
            else more[i]+= c.num
          })
        })

        option = {
          title: {
            text: 'Nombre d\'emprunts par mois par communauté'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: ['1 emprunt', '2 à 10', '11 à 20', 'plus de 20'],
            top: 30,
          },
          color: ['#022f2e', '#005f5a', '#009689', '#00d5be' ],
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: monthsLabel.slice(1),
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '1 emprunt',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: one.slice(1)
            },
            {
              name: '2 à 10',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: twoFive.slice(1)
            },
            {
              name: '11 à 20',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: sixTen.slice(1)
            },
            {
              name: 'plus de 20',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: more.slice(1)
            },
          ]
        };
      }
      option && myChart.setOption(option);
    }
  },
  mounted() {
    if(!this.loading) {
      this.displayChart()
    }
  },
  watch: {
    loading() {
      if(!this.loading) {
        this.displayChart()
      }
    }
  }
}
</script>
